// extracted by mini-css-extract-plugin
export default {"poweredByGoogle":"_3b455770"};